<template>
  <b-card no-body class="card-statistics">
    <b-card-header class="py-1">
      <b-card-title>نگاه کلی</b-card-title>
      <!-- <b-card-text class="font-small-2 mr-25 mb-0">
        آخرین بروز رسانی دو دقیقه قبل
      </b-card-text> -->
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row v-if="loading">
        <b-col v-for="item in 4" :key="item" xl="3" sm="6" >
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-skeleton type="avatar"></b-skeleton>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-skeleton />
              <b-card-text class="font-small-3 mb-0">
                <b-skeleton />
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col v-for="(item, index) in statistics" :key="index" xl="3" sm="6" class="my-xl-0 my-1">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" :variant="item.color">
                <feather-icon size="24" :icon="item.icon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="font-weight-bolder mb-0">
                {{ item.text }}
              </h6>
              <b-card-text class="font-small-3 mb-0">
                {{ item.title }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BSkeleton,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BSkeleton,
  },
  props: {
    statistics: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
